// import analytics from '@utils/analytics';
import { useLangChecker } from '@common/utils/i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
const ReturnExchangeInBoutique = (props) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "d-column row-gap-40" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-24 col-lg-16" },
                    React.createElement("div", { className: "section__description", dangerouslySetInnerHTML: { __html: t('returns.boutiqueintro') } }),
                    React.createElement("br", null),
                    React.createElement("div", { className: "section__description", dangerouslySetInnerHTML: { __html: t('returns.stylingopportunities') } }))),
            React.createElement("div", { className: "row row-gap-12" },
                React.createElement("div", { className: "col-24 col-lg-12" },
                    React.createElement("a", { href: props.boutiqueurl, className: "button button--secondary full" },
                        React.createElement("span", { ref: useLangChecker }, t('button.boutiquelocator')))),
                React.createElement("div", { className: "col-24 col-lg-12" },
                    React.createElement("a", { href: props.locatorurl, className: "button button--secondary full" },
                        React.createElement("span", null, t('button.bookappointment'))))))));
};
export default ReturnExchangeInBoutique;
